import { render, staticRenderFns } from "./VideoControlButton.vue?vue&type=template&id=89a0d918&scoped=true&"
import script from "./VideoControlButton.vue?vue&type=script&lang=js&"
export * from "./VideoControlButton.vue?vue&type=script&lang=js&"
import style0 from "./VideoControlButton.vue?vue&type=style&index=0&id=89a0d918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a0d918",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
